fx.ns("repositories", class InstagramRepository extends fx.ModelArray {

    constructor()
    {
        super([]);
    }

    get selectedPhotos()
    {
        let selectedItems = [];

        for (let i = 0; i < this.length; i++)
        {
            if (this.getItemAt(i).selected)
                selectedItems.push(this.getItemAt(i));
        }

        return selectedItems;
    }

    addPhoto(rawPhoto)
    {
        rawPhoto._m = "InstagramPhotoModel";
        this.addItem(rawPhoto);
    }

    selectAllPhotos()
    {
        for ( let i = 0; i < this.length; i++)
		{
			this.getItemAt(i).selected = true;
		}
    }

    unSelectAllPhotos()
    {
        for (let i = 0; i < this.length; i++)
        {
            this.getItemAt(i).selected = false;
        }
    }

});